var map = {
	"./ava-2.png": 2006,
	"./ava-3.png": 7749,
	"./ava-4.png": 3722,
	"./ava-5.png": 1165,
	"./check.png": 8840,
	"./error.png": 8127,
	"./error404.png": 2923,
	"./life_gray.png": 9508,
	"./life_red.png": 5261,
	"./logo.png": 4427,
	"./main-game-1@2x.png": 9311,
	"./main-game-2.png": 4151,
	"./main-game-2@2x.png": 4179,
	"./main-game-3.png": 5489,
	"./main-game-3@2x.png": 9836,
	"./puzzle-desktop.png": 4845,
	"./puzzle-mobile.png": 6329,
	"./quiz-desktop-old.png": 21,
	"./quiz-desktop.png": 6597,
	"./quiz-mobile-old.png": 2679,
	"./quiz-mobile-old2.png": 2626,
	"./quiz-mobile.png": 3064,
	"./red-brick.png": 8700,
	"./rules-img.png": 9487,
	"./tag-desktop.png": 3368,
	"./tag-mobile.png": 3962,
	"./tetris-desktop.png": 2467,
	"./tetris-mobile.png": 5711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;